import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import TimelineItem, { TimelineItemColorType } from "@/components/atoms/Timeline/TimelineItem";
import { convertIsoToBrazilianDateTime } from "@/helpers/date-helpers";
import { IOrder, IOrderStatus } from "@/interfaces/order.interfaces";
import { OrderTrackingMessages } from "@/messages/order-details/order-tracking.messages";
import { OrderStatus } from "@/types/order.types";

import { statusToIconMap, statusToLabelMap } from "../../../../constants";

type Props = {
  messages: OrderTrackingMessages;
  order: IOrder | null;
};

function TrackOrder({ messages, order }: Props) {
  const { orderTrackingTitle } = messages;

  const statusHistory: IOrderStatus[] = order && Array.isArray(order.status) ? order.status : [];

  const getColorByStatus = (statusCode: OrderStatus): TimelineItemColorType => {
    switch (statusCode) {
      case OrderStatus.Error:
      case OrderStatus.Cancelled:
        return "error";
      case OrderStatus.Delivered:
        return "success";
      case OrderStatus.Paid:
        return "success";
      default:
        return "text"; // Cor padrão para outros status
    }
  };

  const renderTrackItem = (status: IOrderStatus, isLastItem: boolean) => {
    const labelKey = statusToLabelMap[status.statusDetail.code];
    const Icon = statusToIconMap[status.statusDetail.code];
    const label = messages[labelKey];
    const dateTime = convertIsoToBrazilianDateTime(status.rowDate);
    const color = getColorByStatus(status.statusDetail.code);

    return (
      <TimelineItem
        key={status.id}
        color={color} // Define a cor do TimelineItem
        icon={<Icon />} // Renderiza o ícone associado ao status
        title={label} // Exibe o label da mensagem correspondente ao status
        dateTime={dateTime} // Exibe a data formatada
        lastItem={isLastItem} // Define se é o último item
      />
    );
  };

  return (
    <>
      <MDTypography variant="h6" fontWeight="medium">
        {orderTrackingTitle}
      </MDTypography>

      <MDBox mt={2}>
        {statusHistory &&
          statusHistory.map((status, index) =>
            renderTrackItem(status, index === statusHistory.length - 1)
          )}
      </MDBox>
    </>
  );
}

export default TrackOrder;
